// One check-in, asked properly.
//
// The old presentation put every open check-in on screen at once, each with six identical chips.
// That is an interview, and the north star is explicit that check-ins are conversation. So: one
// question, three answers that fit most of the time, and the rarer three folded behind "something
// else" until someone reaches for them.
//
// Shared by the Self tile (which shows the single most relevant one) and the deck page (which
// walks the paced set), so the two surfaces can never drift into asking the same thing differently.

import { useState } from 'react';
import { CHECK_IN_MORE, CHECK_IN_PRIMARY, patternLabel, type PatternCheckIn } from '../api/check-ins';

export function CheckInCard({
  checkIn,
  onAnswer,
  onDefer,
}: {
  checkIn: PatternCheckIn;
  onAnswer: (response: string) => void;
  /** Omitted on the Self tile, where the whole card is already skippable by scrolling past it. */
  onDefer?: () => void;
}) {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="ocheckin">
      {/* Its own class rather than .olabel: that one uppercases, which would put the written name
          straight back into the schema shouting it was written to escape. */}
      <span className="ocheckin-name">{patternLabel(checkIn.canonicalId)}</span>

      <h3 className="ocheckin-q">{checkIn.question || 'Is this still part of your story?'}</h3>

      <div className="ocheckin-answers">
        {CHECK_IN_PRIMARY.map((r) => (
          <button key={r.id} type="button" className="ochip ocheckin-chip" onClick={() => onAnswer(r.id)}>
            {r.label}
          </button>
        ))}
      </div>

      {showMore ? (
        <div className="ocheckin-answers ocheckin-more">
          {CHECK_IN_MORE.map((r) => (
            <button key={r.id} type="button" className="ochip ocheckin-chip" onClick={() => onAnswer(r.id)}>
              {r.label}
            </button>
          ))}
        </div>
      ) : null}

      <div className="ocheckin-foot">
        {showMore ? null : (
          <button type="button" className="ocheckin-quiet" onClick={() => setShowMore(true)}>
            something else
          </button>
        )}
        {onDefer ? (
          <button type="button" className="ocheckin-quiet" onClick={onDefer}>
            not now
          </button>
        ) : null}
      </div>
    </div>
  );
}
